module.exports = __webpack_public_path__ + "static/media/graph2.05f71477.svg";